import { trackProductTileBrandLinkHoverTiming } from "@faire/web-api/events/productTile/timing/brandLinkHover";
import { TimingMarker, TimingPair } from "@faire/web/common/timings/TimingMarker";
import React, { useState } from "react";
import { useCallback, useContext, useMemo } from "react";



import { handleGenerateBrandUrl as handleGenerateBrandUrlCarousel } from "@faire/retailer/components/Carousel/utils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { ProductTileContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { BrandInfoProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { useGetProductTileClickImpressions } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";



import { ProductTileBrandInfoClickContext } from "./ProductTileBrandInfoClickContext";


export const LayoutElementProductTileBrandInfoClickContextProvider: React.FC<{
  data: BrandInfoProps;
  children: React.ReactNode;
}> = ({ data, children }) => {
  const [hoverStartTime, setHoverStartTime] = useState<TimingMarker | null>(
    null
  );
  const { brandToken } = useContext(ProductTileContext);
  const generateBrandUrl = useMemo(
    () => handleGenerateBrandUrlCarousel(brandToken, data.token),
    [brandToken, data.token]
  );

  const { onItemClick, layoutElement, requestId } = React.useContext(Context);

  const { recordBrandNameClickEvent } = useGetProductTileClickImpressions(data);
  const handleOnBrandClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    recordBrandNameClickEvent();
    const endTime = new TimingMarker();
    const timer: TimingPair = {
      start: hoverStartTime ?? endTime,
      end: endTime,
    };
    trackProductTileBrandLinkHoverTiming("click", timer);
    onItemClick?.(
      layoutElement.on_click_event_name ?? "",
      requestId,
      brandToken ?? ""
    );
    e.stopPropagation();
  };

  const onBrandLinkFocus = useCallback(() => {
    if (!hoverStartTime) {
      setHoverStartTime(new TimingMarker());
    }
  }, [hoverStartTime]);
  const onBrandLinkBlur = useCallback(() => {
    const endTime = new TimingMarker();
    const timer: TimingPair = {
      start: hoverStartTime!,
      end: endTime,
    };
    trackProductTileBrandLinkHoverTiming("hover", timer);
  }, [hoverStartTime]);
  return (
    <ProductTileBrandInfoClickContext.Provider
      value={{
        generateBrandUrl,
        onBrandClick: handleOnBrandClick,
        onBrandLinkFocus,
        onBrandLinkBlur,
      }}
    >
      {children}
    </ProductTileBrandInfoClickContext.Provider>
  );
};
